import { supabase } from '../config/supabaseClient';

export interface FinanceInsightInput {
  period_from?: string; // ISO date
  period_to?: string;   // ISO date
  summary?: Record<string, any>;
  kpis?: Record<string, any>;
  recommendations?: Array<{ title: string; detail?: string; actionRoute?: string }>;
}

export interface FinanceInsightRecord extends FinanceInsightInput {
  id: string;
  user_id: string;
  generated_at: string;
  created_at: string;
}

export const financeInsightsService = {
  async create(input: FinanceInsightInput): Promise<FinanceInsightRecord> {
    const { data: session } = await supabase.auth.getSession();
    const userId = session.session?.user?.id;
    if (!userId) throw new Error('Not authenticated');

    const payload = {
      user_id: userId,
      period_from: input.period_from ?? null,
      period_to: input.period_to ?? null,
      summary: input.summary ?? {},
      kpis: input.kpis ?? {},
      recommendations: input.recommendations ?? [],
    };

    const { data, error } = await supabase
      .from('finance_insights')
      .insert(payload)
      .select()
      .single();

    if (error) throw error;
    return data as FinanceInsightRecord;
  },

  async list(limit = 10): Promise<FinanceInsightRecord[]> {
    const { data: session } = await supabase.auth.getSession();
    const userId = session.session?.user?.id;
    if (!userId) throw new Error('Not authenticated');

    const { data, error } = await supabase
      .from('finance_insights')
      .select('*')
      .eq('user_id', userId)
      .order('generated_at', { ascending: false })
      .limit(limit);

    if (error) throw error;
    return (data || []) as FinanceInsightRecord[];
  }
};
